/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { subscriptionListInput } from '../../../dataActions/DataActionExtension.g';
import { IrsmSubscriptionListResponse } from '../../../dataActions/DataServiceEntities.g';

/**
 * GetSubscriptions Input Action
 */
export class GetSubscriptionsInput implements Msdyn365.IActionInput {
    public input: IDataServiceRequest;
    constructor(input: IDataServiceRequest) {
        this.input = input;
    }

    public shouldCacheOutput = () => false;

    public getCacheKey = () => `IGetSubscriptionsInput`;
    public getCacheObjectType = () => 'IGetSubscriptionsInput';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetSubscriptionsData extends IrsmSubscriptionListResponse {}

export interface IInputRequirements {
    customerId: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
export const createGetSubscriptionsInput = (args: Msdyn365.ICreateActionContext, input: IInputRequirements): GetSubscriptionsInput => {
    const accNumber = args.requestContext.user.customerAccountNumber || input.customerId;
    return new GetSubscriptionsInput(
        subscriptionListInput(String(accNumber))
    );
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getSubscriptionsAction(input: GetSubscriptionsInput, ctx: Msdyn365.IActionContext): Promise<IGetSubscriptionsData> {
    return input.input.execute(ctx);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetSubscriptionsData>>getSubscriptionsAction,
    input: createGetSubscriptionsInput
});
